// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3KO29","Success":"Button_Success__3gMk1","Danger":"Button_Danger__fXxW0"};